import i18n from "@/i18n/i18n"

export const AppBannerOptions = [
  {
    label: i18n.t('上下结构'),
    value: '1'
  },
  {
    label: i18n.t('左右结构'),
    value: '2'
  },
  {
    label: i18n.t('上左右结构'),
    value: '3'
  },
]

export const AppThemeOptions = [
  {
    label: i18n.t('深色'),
    value: '1'
  },
  {
    label: i18n.t('浅色'),
    value: '2'
  }
]

export const AppStatusOptions = [
  {
    label: i18n.t('待发布'),
    value: '0'
  },
  {
    label: i18n.t('已发布'),
    value: '1'
  },
  {
    label: i18n.t('已取消'),
    value: '2'
  },
]

export const PageLoadTypeOptions = [
  {
    label: i18n.t('默认'),
    value: '2'
  },
  {
    label: i18n.t('从外链加载'),
    value: '0'
  },
  {
    label: i18n.t('从文件加载'),
    value: '1'
  },
]